import './auth_method.component.scss';
import tpl from './auth_method.tpl.html';

import authMethodResourceMod from './auth_method.resource';
import urlServiceMod from '../common/url.service';

import APP_CONFIG from "../app.config";
import {buildQueryFromDict} from "../common/common.urls";
import {getLanguage} from "../common/language.utils";

/**
 * List of authentication service URLs that will be whitelisted in the interpolation system.
 * @type {Array.<string>}
 */
const AUTH_SERVICE_URLS = [
  'self',
];

/**
 * Component for showing a list of the TUPAS banks that can be clicked on to initiate login / registration flow.
 */
class AuthMethodComponent {
  constructor($log, $scope, $timeout, $element, $compile, AuthMethodResource, UrlService) {
    this.$log = $log;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.$compile = $compile;
    this.AuthMethodResource = AuthMethodResource;
    this.UrlService = UrlService;

    /**
     * Path to redirect to after coming back from TUPAS login.
     *
     * Must be relative path. Can include query, hash or both. By default no page is set (registered will go to OmaOral,
     * unregistered to registration page).
     *
     * @type {string}
     */
    this.redirectPath = null;
    this.failureRedirectPath = null;

    /**
     * List of banks to display in grid.
     * @type {Array.<AuthMethod>}
     */
    this.auth_methods = null;

    /**
     * Loading banks?
     * @type {boolean}
     */
    this.loading = true;
  }

  $onInit() {
    this.AuthMethodResource.getAll().then(auth_methods => {
      this.auth_methods = auth_methods.list;
      this.loading = false;
    });
  }

  /**
   * Start OIDC login flow with selected auth method
   * @param {AuthMethod} method
   */
  startLoginFlow(method) {
    const params = {
      method: method.auth_id,
      language: getLanguage()
    };

    if (this.redirectPath != null) {
      params['return'] = this.UrlService.getRelativePath(this.redirectPath);
    }
    if (this.failureRedirectPath != null) {
      params['failure_return'] = this.UrlService.getRelativePath(this.failureRedirectPath);
    }

    const url = `${APP_CONFIG.be}/oidc/authenticate/?${buildQueryFromDict(params)}`;
    this.$log.debug("Init login flow with url", url);
    window.location.href = url;
  }
}

const config = {
  templateUrl: tpl,
  controller: AuthMethodComponent,
  bindings: {
    redirectPath: '<?',
    failureRedirectPath: '<?',
  }
};

const mod = angular.module('app.auth_method.authMethodComponent', [
  authMethodResourceMod,
  urlServiceMod,
])

.component('authMethods', config);

/**
 * Configure the AngularJS interpolation system to allow the following URLs. This is required to interpolate URLs to
 * TUPAS login pages.
 */
function whitelistAuthURLs($sceDelegateProvider) {
  'ngInject';

  $sceDelegateProvider.resourceUrlWhitelist(
    $sceDelegateProvider.resourceUrlWhitelist().concat(AUTH_SERVICE_URLS)
  );
}
whitelistAuthURLs.imports = [];

export {whitelistAuthURLs};
export default mod.name;
